export default function() {
    return {
        banners: [],
        showDeleteConfirmationModal: false,
        deleteBanner: null,
        fields: [
            {
                key: 'image',
                label: 'Imagem'
            },
            {
                key: 'title',
                label: 'Título'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ]
    }
}
